import * as c from 'common/c'

export const adsLoading = () => {
  return {
    type: c.ADS_LOADING,
  }
}

export const adsFetched = (data) => {
  return {
    type: c.ADS_FETCHED,
    payload: data,
  }
}

export const adsError = () => {
  return {
    type: c.ADS_ERROR,
  }
}
